import { convertQueryCommandToQueryString, convertStringToQueryCommand, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { Equal, QueryStringCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IHydraInvoiceForOutstandingInvoices } from '../../shared/interfaces/hydra-invoice';

// Base store configuration
const adminGatewayResourcePath: string = '/billing-api/reporting/outstanding-invoices';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: QueryStringCommandOptions = {
  page: 1,
  limit: 20,
};
const defaultGetSingleFilters: QueryStringCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementation<IHydraInvoiceForOutstandingInvoices>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'outstanding-notifications/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
    get: async (ctx:IAction<IStateStrict<IHydraInvoiceForOutstandingInvoices>>, payload:IQueryCommandOptions) => {
      const result = await adminRequest.get(`${adminGatewayResourcePath}${convertQueryCommandToQueryString(payload)}`);
      ctx.commit('set', result);
    },
  },
};
